import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import type { ClassValue } from 'clsx';

const extendedTwMerge = extendTailwindMerge({
  prefix: 'tw-',
});

export function cn(...inputs: Array<ClassValue>) {
  return extendedTwMerge(clsx(inputs));
}
